import { cnpjNumber, cpfCnpjNumber, cpfNumber } from '../common/validations/social';
import decimalComma from '../common/validations/decimal';
import moneyRequired from '../common/validations/money-required';
import moneyMax from '../common/validations/money-max';
import dataVal from '../common/validations/time';

const messages = {
  moneyrequired: () => 'Este campo é obrigatório',
  moneymax: () => 'Excedeu o valor disponível.',
  required: () => 'Este campo é obrigatório',
  email: () => 'Este email é inválido',
  digits: (value, args) => `Campo numérico com ${args} dígitos obrigatórios`,
  decimalcomma: (value, args) => `Máximo de ${args} casas decimais`,
  min_value: (value, args) => `O valor mínimo é ${args}`,
  max_value: (value, args) => `O valor máximo é ${Number(args).toLocaleString()}`,
  max: (value, args) => `Máximo de ${args} dígitos`,
  numeric: () => 'Este campo aceita apenas números',
  date_format: () => 'Data inválido',
};

const dictionary = {
  en: {
    messages,
  },
  pt: {
    messages,
  },
  ptbr: {
    messages,
  },
};

export default (Validator) => {
  // Exemplo de como usar um validator customizado
  Validator.extend('cnpj', cnpjNumber);
  Validator.extend('cpf', cpfNumber);
  Validator.extend('cpfcnpj', cpfCnpjNumber);
  Validator.extend('decimalcomma', decimalComma);
  Validator.extend('dateformat', dataVal);
  Validator.extend('moneyrequired', moneyRequired);
  Validator.extend('moneymax', moneyMax);
  Validator.updateDictionary(dictionary);
};



// WEBPACK FOOTER //
// ./src/config/validations.js